import { ServerWorkspace, Workspace } from '@/shared/types';

const mapBaseServerWorkspace = (
  workspace: ServerWorkspace,
  isMember: boolean
): Workspace => ({
  id: workspace.workspaceId,
  isDefault: workspace.default,
  name: workspace.workspaceName,
  projectsCount: workspace.projectCount,
  membersCount: workspace.totalMembers,
  createdBy: workspace.createdBy ?? workspace.workspaceCreator ?? '',
  organizationId: workspace.organizationId,
  createdAt: workspace.createdAt,
  storageUsage: workspace.storageUsage,
  collaborationFeaturesDisabled: workspace.collaborationFeaturesDisabled,
  isMember
});

export const mapServerWorkspacePublic = (
  workspace: ServerWorkspace
): Workspace => mapBaseServerWorkspace(workspace, false);

export const mapServerWorkspaceForMember = (
  workspace: ServerWorkspace
): Workspace => mapBaseServerWorkspace(workspace, true);
